import React, { useEffect, useState } from "react";
import {
  fetchRatingsByDish,
  fetchRatingsByWaiter,
  fetchRatingsFeed,
  fetchRatingsCoverage,
  resolveImageUrl,
} from "../services/api";
import { parseServerDate } from "../utils/time";
import { useT } from "../i18n/useT";

// AM/OM are machine drafts (2026-06) — pending native review
const STRINGS = {
  en: {
    could_not_load: "Could not load ratings.",
    win_today: "Today",
    win_week: "Last 7 days",
    win_month: "Last 30 days",
    win_all: "All time",
    page_title: "Ratings & bonuses",
    loading: "Loading…",
    by_waiter: "👤 By waiter",
    by_waiter_sub: "Five-star count is the simplest input for bonus payroll. Higher = better.",
    no_ratings_window: "No ratings yet for this window.",
    coverage_label: "Rating coverage", coverage_text: "{r} of {t} orders rated ({p}%)", coverage_low: "small sample — read averages with care",
    custom_from: "From",
    custom_to: "To",
    custom_clear: "Clear",
    th_waiter: "Waiter",
    th_avg_service: "Avg service",
    th_avg_food: "Avg food",
    th_ratings: "Ratings",
    th_five_star: "5-star (bonus eligible)",
    th_last_rated: "Last rated",
    by_dish: "🍽 By dish",
    by_dish_sub: "Sorted by avg food rating. A 5-star avg from one rating is less interesting than a 4.5 from 30 — eyeball the rating count.",
    no_rated_dishes: "No rated dishes yet for this window.",
    th_dish: "Dish",
    th_category: "Category",
    th_avg_food_rating: "Avg food rating",
    th_sold_qty: "Sold (qty)",
    recent_comments: "💬 Recent comments",
    no_comments: "No written comments yet.",
    order_no: "Order #{n}",
    food_service_summary: "· food {f}/5 · service {s}/5",
    label_food: "food:",
    label_service: "service:",
    no_comment: "(no comment)",
  },
  am: {
    could_not_load: "ግምገማዎችን መጫን አልተቻለም።",
    win_today: "ዛሬ",
    win_week: "ያለፉት 7 ቀናት",
    win_month: "ያለፉት 30 ቀናት",
    win_all: "ሁሉም ጊዜ",
    page_title: "ግምገማዎች እና ጉርሻዎች",
    loading: "በመጫን ላይ…",
    by_waiter: "👤 በአስተናጋጅ",
    by_waiter_sub: "የአምስት-ኮከብ ቁጥር ለጉርሻ ክፍያ በጣም ቀላሉ መነሻ ነው። ከፍ ያለ = የተሻለ።",
    no_ratings_window: "ለዚህ ጊዜ እስካሁን ምንም ግምገማ የለም።",
    coverage_label: "የግምገማ ሽፋን", coverage_text: "ከ{t} ትዕዛዞች {r} ተገምግመዋል ({p}%)", coverage_low: "አነስተኛ ናሙና — አማካዮችን በጥንቃቄ ይመልከቱ",
    custom_from: "ከ",
    custom_to: "እስከ",
    custom_clear: "አጽዳ",
    th_waiter: "አስተናጋጅ",
    th_avg_service: "አማካይ አገልግሎት",
    th_avg_food: "አማካይ ምግብ",
    th_ratings: "ግምገማዎች",
    th_five_star: "5-ኮከብ (ጉርሻ የሚገባው)",
    th_last_rated: "መጨረሻ የተገመገመ",
    by_dish: "🍽 በምግብ",
    by_dish_sub: "በአማካይ የምግብ ግምገማ የተደረደረ። ከአንድ ግምገማ የመጣ 5-ኮከብ አማካይ ከ30 ከመጣ 4.5 ያነሰ ትኩረት የሚስብ ነው — የግምገማውን ቁጥር ይመልከቱ።",
    no_rated_dishes: "ለዚህ ጊዜ እስካሁን የተገመገሙ ምግቦች የሉም።",
    th_dish: "ምግብ",
    th_category: "ምድብ",
    th_avg_food_rating: "አማካይ የምግብ ግምገማ",
    th_sold_qty: "የተሸጠ (ብዛት)",
    recent_comments: "💬 የቅርብ ጊዜ አስተያየቶች",
    no_comments: "እስካሁን የተጻፈ አስተያየት የለም።",
    order_no: "ትዕዛዝ #{n}",
    food_service_summary: "· ምግብ {f}/5 · አገልግሎት {s}/5",
    label_food: "ምግብ:",
    label_service: "አገልግሎት:",
    no_comment: "(ምንም አስተያየት የለም)",
  },
  om: {
    could_not_load: "Madaallii fe'uu hin dandeenye.",
    win_today: "Har'a",
    win_week: "Guyyoota 7 darban",
    win_month: "Guyyoota 30 darban",
    win_all: "Yeroo hunda",
    page_title: "Madaallii fi badhaasa",
    loading: "Fe'aat jira…",
    by_waiter: "👤 Tajaajilaadhaan",
    by_waiter_sub: "Lakkoofsi urjii-shanii kaffaltii badhaasaaf galtee salphaa dha. Ol'aanaa = caalaa gaarii.",
    no_ratings_window: "Yeroo kanaaf ammaaf madaalliin hin jiru.",
    coverage_label: "Haguuggii madaallii", coverage_text: "ajaja {t} keessaa {r} madaalaman ({p}%)", coverage_low: "saampilii xiqqaa — giddugaleessa of eeggannoon ilaali",
    custom_from: "Irraa",
    custom_to: "Hanga",
    custom_clear: "Haqi",
    th_waiter: "Tajaajilaa",
    th_avg_service: "Tajaajila giddu-galeessa",
    th_avg_food: "Nyaata giddu-galeessa",
    th_ratings: "Madaallii",
    th_five_star: "Urjii-5 (badhaasaaf ulaagaa)",
    th_last_rated: "Kan dhumaa madaalame",
    by_dish: "🍽 Nyaataan",
    by_dish_sub: "Madaallii nyaataa giddu-galeessaan tartiibeffame. Urjii-5 giddu-galeessi madaallii tokko irraa argame, 4.5 madaallii 30 irraa caalaa xiqqaa xiyyeeffannaa argata — lakkoofsa madaallii ilaali.",
    no_rated_dishes: "Yeroo kanaaf ammaaf nyaatonni madaalaman hin jiran.",
    th_dish: "Nyaata",
    th_category: "Ramaddii",
    th_avg_food_rating: "Madaallii nyaataa giddu-galeessa",
    th_sold_qty: "Kan gurguramae (baay'ina)",
    recent_comments: "💬 Yaadota dhiheenyaa",
    no_comments: "Ammaaf yaadni barreeffame hin jiru.",
    order_no: "Ajaja #{n}",
    food_service_summary: "· nyaata {f}/5 · tajaajila {s}/5",
    label_food: "nyaata:",
    label_service: "tajaajila:",
    no_comment: "(yaadni hin jiru)",
  },
};

/**
 * Manager Ratings dashboard.
 *
 * Three sections, all driven by the same time-window picker:
 *   1. By waiter -- avg service rating, avg food, count, five-star count.
 *      "Five-star count" is intentionally surfaced separately because
 *      hotel managers told us they will pay bonuses on it.
 *   2. By dish -- avg food rating per menu item, with quantity sold so
 *      the manager can spot dishes that drag the average down.
 *   3. Comments feed -- latest 50 ratings with their text comments.
 */

const WINDOWS = [
  { key: "today", labelKey: "win_today" },
  { key: "week", labelKey: "win_week" },
  { key: "month", labelKey: "win_month" },
  { key: "all", labelKey: "win_all" },
];

function Stars({ value }) {
  // Render avg rating as five-star block with partial fill.
  const pct = Math.max(0, Math.min(100, (value / 5) * 100));
  return (
    <span className="stars" style={{ position: "relative", display: "inline-block", letterSpacing: 1 }}>
      <span style={{ color: "#cbd2d9" }}>★★★★★</span>
      <span
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          color: "#d4af37",
          width: `${pct}%`,
          overflow: "hidden",
          whiteSpace: "nowrap",
        }}
      >★★★★★</span>
    </span>
  );
}

function fmtDate(s) {
  if (!s) return "—";
  try { return parseServerDate(s).toLocaleString(); } catch { return s; }
}

function WordCloud({ texts }) {
  const STOP = new Set(("the a an and or but is was are were be been being to of in on at for with it this that these those they we you i my our your really so just too also not no nor only own same than then once here there all any both each few more most other some such had has have do did does will would can could should our the").split(" "));
  const freq = {};
  (texts || []).forEach((tx) => {
    String(tx || "").toLowerCase().replace(/[^\p{L}\s]/gu, " ").split(/\s+/).forEach((w) => {
      if (w.length < 2 || STOP.has(w)) return;
      freq[w] = (freq[w] || 0) + 1;
    });
  });
  const words = Object.entries(freq).sort((a, b) => b[1] - a[1]).slice(0, 30);
  if (!words.length) return null;
  const max = words[0][1], min = words[words.length - 1][1];
  const colors = ["#008080", "#063b48", "#BA7517", "#378ADD", "#1D9E75", "#7F77DD", "#639922"];
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "4px 12px", alignItems: "center", justifyContent: "center", padding: "14px 6px" }}>
      {words.map(([w, c], i) => {
        const tt = max === min ? 1 : (c - min) / (max - min);
        return (
          <span key={w} title={`${c}×`} style={{ fontSize: 13 + tt * 22, fontWeight: 500 + Math.round(tt * 200), color: colors[i % colors.length], lineHeight: 1.1 }}>
            {w}
          </span>
        );
      })}
    </div>
  );
}

export default function ManagerRatingsPage() {
  const { lang } = useT();
  const t = (k) => (STRINGS[lang] && STRINGS[lang][k]) || STRINGS.en[k] || k;
  const [win, setWin] = useState("week");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [byWaiter, setByWaiter] = useState([]);
  const [byDish, setByDish] = useState([]);
  const [feed, setFeed] = useState([]);
  const [coverage, setCoverage] = useState(null);
  const commentItems = feed.filter((r) => r.food_comment || r.service_comment);
  const commentTexts = commentItems.flatMap((r) => [r.food_comment, r.service_comment].filter(Boolean));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const customActive = Boolean(customStart && customEnd);
  const range = customActive ? { start: customStart, end: customEnd } : { window: win };
  const rangeKey = JSON.stringify(range);
  const pickPreset = (k) => { setWin(k); setCustomStart(""); setCustomEnd(""); };

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchRatingsByWaiter(range),
      fetchRatingsByDish(range),
      fetchRatingsFeed(50, range),
      fetchRatingsCoverage(range),
    ])
      .then(([w, d, f, cov]) => {
        setByWaiter(w);
        setByDish(d);
        setFeed(f);
        setCoverage(cov);
        setError(null);
      })
      .catch((e) =>
        setError(
          e?.response?.data?.detail?.message ||
            e?.response?.data?.detail ||
            t("could_not_load")
        )
      )
      .finally(() => setLoading(false));
  }, [rangeKey]);  // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="space-between" style={{ marginBottom: 16 }}>
        <h1>{t("page_title")}</h1>
        <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <div className="tabs" style={{ margin: 0 }}>
            {WINDOWS.map((w) => (
              <div
                key={w.key}
                className={"tab " + (!customActive && win === w.key ? "active" : "")}
                onClick={() => pickPreset(w.key)}
              >
                {t(w.labelKey)}
              </div>
            ))}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: "0.85rem" }}>
            <span className="muted">{t("custom_from")}</span>
            <input type="date" value={customStart} max={customEnd || undefined}
                   onChange={(e) => setCustomStart(e.target.value)} />
            <span className="muted">{t("custom_to")}</span>
            <input type="date" value={customEnd} min={customStart || undefined}
                   onChange={(e) => setCustomEnd(e.target.value)} />
            {customActive && (
              <button type="button" className="btn secondary small"
                      onClick={() => { setCustomStart(""); setCustomEnd(""); }}>
                {t("custom_clear")}
              </button>
            )}
          </div>
        </div>
      </div>

      {error && <div className="error">{error}</div>}
      {loading && <p className="muted">{t("loading")}</p>}

      {coverage && coverage.total_orders > 0 && (
        <div className="card" style={{ marginBottom: 16, padding: "10px 14px", borderLeft: `4px solid ${coverage.coverage_pct < 20 ? "#BA7517" : "#1D9E75"}`, background: coverage.coverage_pct < 20 ? "#FAEEDA" : "#E1F5EE" }}>
          <b style={{ color: coverage.coverage_pct < 20 ? "#633806" : "#085041" }}>{t("coverage_label")}: </b>
          <span style={{ color: coverage.coverage_pct < 20 ? "#633806" : "#085041" }}>
            {t("coverage_text").replace("{r}", coverage.rated_orders).replace("{t}", coverage.total_orders).replace("{p}", coverage.coverage_pct)}
          </span>
          {coverage.rated_orders < 5 && <span className="muted"> — {t("coverage_low")}</span>}
        </div>
      )}

      {/* By waiter */}
      <section className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ marginTop: 0 }}>{t("by_waiter")}</h3>
        <p className="muted" style={{ marginTop: -8 }}>
          {t("by_waiter_sub")}
        </p>
        {byWaiter.length === 0 ? (
          <p className="muted">{t("no_ratings_window")}</p>
        ) : (
          <table className="data" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>{t("th_waiter")}</th>
                <th>{t("th_avg_service")}</th>
                <th>{t("th_avg_food")}</th>
                <th>{t("th_ratings")}</th>
                <th>{t("th_five_star")}</th>
                <th>{t("th_last_rated")}</th>
              </tr>
            </thead>
            <tbody>
              {byWaiter.map((r) => (
                <tr key={r.staff_id}>
                  <td>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                      {r.photo_url ? (
                        <img src={resolveImageUrl(r.photo_url)} alt="" style={{ width: 30, height: 30, borderRadius: "50%", objectFit: "cover" }} />
                      ) : (
                        <span style={{ width: 30, height: 30, borderRadius: "50%", background: "#e6eaee", display: "inline-flex", alignItems: "center", justifyContent: "center", color: "#6b7484", fontWeight: 700, fontSize: "0.8rem" }}>
                          {(r.name || r.email || "?").trim().charAt(0).toUpperCase()}
                        </span>
                      )}
                      <span>
                        <b>{r.name || r.email}</b>
                        {r.email && r.name && (
                          <div className="muted" style={{ fontSize: ".8rem" }}>{r.email}</div>
                        )}
                      </span>
                    </span>
                  </td>
                  <td>
                    <Stars value={r.avg_service} />{" "}
                    <span className="muted">{r.avg_service.toFixed(2)}</span>
                  </td>
                  <td>
                    <Stars value={r.avg_food} />{" "}
                    <span className="muted">{r.avg_food.toFixed(2)}</span>
                  </td>
                  <td>{r.rating_count}</td>
                  <td><b>{r.five_star_count}</b></td>
                  <td className="muted">{fmtDate(r.last_rated_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>

      {/* By dish */}
      <section className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ marginTop: 0 }}>{t("by_dish")}</h3>
        <p className="muted" style={{ marginTop: -8 }}>
          {t("by_dish_sub")}
        </p>
        {byDish.length === 0 ? (
          <p className="muted">{t("no_rated_dishes")}</p>
        ) : (
          <table className="data" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>{t("th_dish")}</th>
                <th>{t("th_category")}</th>
                <th>{t("th_avg_food_rating")}</th>
                <th>{t("th_ratings")}</th>
                <th>{t("th_sold_qty")}</th>
              </tr>
            </thead>
            <tbody>
              {byDish.map((d) => (
                <tr key={d.menu_id}>
                  <td>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                      {d.image_url ? (
                        <img src={resolveImageUrl(d.image_url)} alt="" style={{ width: 36, height: 36, borderRadius: 8, objectFit: "cover" }} />
                      ) : (
                        <span style={{ width: 36, height: 36, borderRadius: 8, background: "#eef2f6", display: "inline-block" }} />
                      )}
                      <b>{d.name}</b>
                    </span>
                  </td>
                  <td className="muted">{d.category || "—"}</td>
                  <td>
                    <Stars value={d.avg_food} />{" "}
                    <span className="muted">{d.avg_food.toFixed(2)}</span>
                  </td>
                  <td>{d.rating_count}</td>
                  <td>{d.quantity_sold}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>

      {/* Comments feed */}
      <section className="card">
        <h3 style={{ marginTop: 0 }}>{t("recent_comments")}</h3>
        {commentItems.length === 0 ? (
          <p className="muted">{t("no_comments")}</p>
        ) : (
          <>
          <WordCloud texts={commentTexts} />
          <ul style={{ listStyle: "none", padding: 0 }}>
            {commentItems.map((r) => (
              <li
                key={r.id}
                style={{
                  borderBottom: "1px solid var(--border)",
                  padding: "10px 0",
                }}
              >
                <div className="space-between">
                  <div>
                    <b>{t("order_no").replace("{n}", r.order_id)}</b>{" "}
                    <span className="muted" style={{ fontSize: ".85rem" }}>
                      {t("food_service_summary").replace("{f}", r.food_rating).replace("{s}", r.service_rating)}
                    </span>
                  </div>
                  <span className="muted" style={{ fontSize: ".8rem" }}>
                    {fmtDate(r.created_at)}
                  </span>
                </div>
                {r.food_comment && (
                  <div style={{ marginTop: 4 }}>
                    <span className="muted">{t("label_food")}</span> {r.food_comment}
                  </div>
                )}
                {r.service_comment && (
                  <div style={{ marginTop: 2 }}>
                    <span className="muted">{t("label_service")}</span> {r.service_comment}
                  </div>
                )}
                {!r.food_comment && !r.service_comment && (
                  <div className="muted" style={{ marginTop: 4, fontStyle: "italic" }}>
                    {t("no_comment")}
                  </div>
                )}
              </li>
            ))}
          </ul>
          </>
        )}
      </section>
    </>
  );
}
